var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"labelcont column"},[_c('div',{staticClass:"labelfont"},[_vm._v(" "+_vm._s(this.label)+" ")]),_c('div',{staticClass:"labeltxt",style:(_vm.stilot)},[_vm._v(" "+_vm._s(this.txt)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }